/* Fator 5 — Cabecalho: menu lateral (celular e tablet), menu do topo (rolagem + submenus) e busca com sugestoes. */
(function () {
  var drawer = document.querySelector('[data-drawer]');
  if (!drawer) return;
  var openBtn = document.querySelector('[data-drawer-open]');
  var panel = drawer.querySelector('.drawer__panel');
  var closeEls = drawer.querySelectorAll('[data-drawer-close]');

  // Links e botões visíveis do menu (submenu fechado é display: none e fica de fora).
  function focaveis() {
    return Array.prototype.filter.call(panel.querySelectorAll('a[href], button'), function (el) { return el.getClientRects().length > 0; });
  }

  // O menu fica sempre montado (section-header.css): abrir e fechar é só a classe is-open.
  // menu-aberto no body esconde o botão do WhatsApp (snippets/whatsapp-float.liquid).
  function open() {
    drawer.classList.add('is-open');
    document.body.classList.add('menu-aberto');
    document.body.style.overflow = 'hidden';
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    var f = focaveis()[0];   // o X: quem usa teclado ou leitor de tela começa dentro do menu
    if (f) f.focus({ preventScroll: true });
  }
  function close() {
    drawer.classList.remove('is-open');
    document.body.classList.remove('menu-aberto');
    document.body.style.overflow = '';
    if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus({ preventScroll: true }); }
  }
  if (openBtn) openBtn.addEventListener('click', open);
  closeEls.forEach(function (el) { el.addEventListener('click', close); });
  // Esc fecha; Tab e Shift+Tab andam só dentro do menu enquanto ele está aberto (aria-modal), dando a volta.
  // stopPropagation: o banner de cookies da Shopify escuta o 1º Tab da página no window e puxa o foco para ele;
  // assim ele espera o menu fechar.
  document.addEventListener('keydown', function (e) {
    if (!drawer.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var l = focaveis();
    if (!l.length) return;
    e.preventDefault(); e.stopPropagation();
    var i = l.indexOf(document.activeElement);   // -1 = foco fora do menu: Tab vai ao primeiro, Shift+Tab ao último
    l[e.shiftKey ? (i <= 0 ? l.length - 1 : i - 1) : (i + 1) % l.length].focus();
  });

  drawer.querySelectorAll('[data-acc]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sub = btn.nextElementSibling;
      var isOpen = sub.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });
})();

/* ===== Menu do topo: rolagem horizontal arrastando + submenus presos ao corpo da pagina =====
   Igual ao oficial: o menu ocupa o espaco que sobra e rola; o submenu e' posicionado em tela cheia
   (position: fixed) para nao ser cortado pela rolagem. */
(function () {
  var nav = document.querySelector('.site-nav');
  if (!nav) return;

  var openItem = null, closeTimer = null;
  function place(item, sub) {
    var link = item.querySelector('.site-nav__link');
    var r = (link || item).getBoundingClientRect();
    if (sub.parentNode !== document.body) document.body.appendChild(sub);
    sub.style.top = Math.round(r.bottom) + 'px';
    var left = Math.round(r.left);
    var max = document.documentElement.clientWidth - sub.offsetWidth - 8;
    if (left > max) left = Math.max(8, max);
    sub.style.left = left + 'px';
  }
  function openSub(item) {
    var sub = item.__sub;
    if (!sub) return;
    clearTimeout(closeTimer);
    if (openItem && openItem !== item) closeSub(openItem);
    place(item, sub);
    sub.classList.add('is-open');
    openItem = item;
  }
  function closeSub(item) {
    if (!item || !item.__sub) return;
    item.__sub.classList.remove('is-open');
    if (openItem === item) openItem = null;
  }
  function closeSoon(item) { clearTimeout(closeTimer); closeTimer = setTimeout(function () { closeSub(item); }, 120); }

  nav.querySelectorAll('.site-nav__item--has-children').forEach(function (item) {
    var sub = item.querySelector('.site-nav__submenu');
    if (!sub) return;
    item.__sub = sub;
    item.addEventListener('mouseenter', function () { openSub(item); });
    item.addEventListener('mouseleave', function () { closeSoon(item); });
    sub.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    sub.addEventListener('mouseleave', function () { closeSoon(item); });
    item.addEventListener('focusin', function () { openSub(item); });
    item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget) && !sub.contains(e.relatedTarget)) closeSoon(item); });
    sub.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget) && !sub.contains(e.relatedTarget)) closeSoon(item); });
    sub.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeSub(item); var l = item.querySelector('.site-nav__link'); if (l) l.focus(); } });
  });
  function closeAll() { if (openItem) closeSub(openItem); }
  nav.addEventListener('scroll', closeAll);
  window.addEventListener('resize', closeAll);
  window.addEventListener('scroll', closeAll, true);

  /* arrastar para rolar (o oficial usa cursor grab/grabbing) */
  var down = false, moved = false, startX = 0, startScroll = 0;
  nav.addEventListener('pointerdown', function (e) {
    if (e.button !== 0) return;
    down = true; moved = false; startX = e.clientX; startScroll = nav.scrollLeft;
  });
  nav.addEventListener('pointermove', function (e) {
    if (!down) return;
    var dx = e.clientX - startX;
    if (!moved && Math.abs(dx) > 4) { moved = true; nav.classList.add('is-dragging'); closeAll(); }
    if (moved) { nav.scrollLeft = startScroll - dx; e.preventDefault(); }
  });
  function endDrag() { down = false; nav.classList.remove('is-dragging'); setTimeout(function () { moved = false; }, 0); }
  nav.addEventListener('pointerup', endDrag);
  nav.addEventListener('pointercancel', endDrag);
  nav.addEventListener('pointerleave', endDrag);
  nav.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  nav.addEventListener('dragstart', function (e) { e.preventDefault(); });
})();

/* ===== Busca com sugestoes (igual ao painel do site oficial) =====
   Vazio: HISTORICO (localStorage) + MAIS BUSCADOS (configuracao da secao).
   Digitando: termos sugeridos + PRODUTOS SUGERIDOS via /search/suggest (busca preditiva do Shopify). */
(function () {
  var wrap = document.querySelector('[data-search]');
  if (!wrap) return;
  var form = wrap.querySelector('[data-search-form]');
  var input = wrap.querySelector('[data-search-input]');
  var dd = wrap.querySelector('[data-search-dropdown]');
  if (!form || !input || !dd) return;
  var suggestUrl = wrap.getAttribute('data-suggest-url') || '/search/suggest';
  var searchUrl = form.getAttribute('action') || '/search';
  var topTerms = (wrap.getAttribute('data-top-terms') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  var KEY = 'f5:search-history', MAX_HISTORY = 5, LIMIT = 5;
  var timer = null, seq = 0, ctrl = null, isOpen = false, skipFocus = false;
  var mq = window.matchMedia('(max-width: 1279px)');
  var ICON_SEARCH = '<svg class="site-search__item-icon" viewBox="0 0 256 256" fill="none" stroke="currentColor" stroke-width="16" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="116" cy="116" r="84"/><line x1="175.4" y1="175.4" x2="224" y2="224"/></svg>';
  var ICON_HISTORY = '<svg class="site-search__item-icon" viewBox="0 0 256 256" fill="none" stroke="currentColor" stroke-width="18" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M128 80v48m41.6 24L128 128m56.2-28.3h40v-40"/><path d="M190.2 190.2a88 88 0 1 1 0-124.4l34 33.9"/></svg>';

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* Busca por número de perfume procura só no nome (regra em layout/theme.liquid: "82" → title:82). */
  function porNome(q, digitando) { return (window.f5BuscaPorNome && window.f5BuscaPorNome(q, digitando)) || null; }
  function legivel(q) { return window.f5BuscaLegivel ? window.f5BuscaLegivel(q) : q; }
  function termUrl(t) { return searchUrl + '?q=' + encodeURIComponent(porNome(t) || t) + '&type=product&options%5Bprefix%5D=last'; }
  function money(v) { var n = parseFloat(v); if (isNaN(n)) return ''; var p = n.toFixed(2).split('.'); return 'R$ ' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1]; }
  function sized(url, w) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function history() { try { var h = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(h) ? h : []; } catch (e) { return []; } }
  function saveHistory(t) {
    t = (t || '').trim(); if (!t) return;
    var h = history().filter(function (x) { return String(x).toLowerCase() !== t.toLowerCase(); });
    h.unshift(t);
    try { localStorage.setItem(KEY, JSON.stringify(h.slice(0, MAX_HISTORY))); } catch (e) {}
  }
  function clearHistory() { try { localStorage.removeItem(KEY); } catch (e) {} }

  function placeSheet() {
    if (mq.matches) {
      if (dd.parentNode !== document.body) document.body.appendChild(dd);
      dd.classList.add('site-search__dropdown--sheet');
      dd.style.top = Math.round(form.getBoundingClientRect().bottom + 6) + 'px';
    } else {
      if (dd.parentNode !== wrap) wrap.appendChild(dd);
      dd.classList.remove('site-search__dropdown--sheet');
      dd.style.top = '';
    }
  }
  function show(html) {
    if (!html) { hide(); return; }
    dd.innerHTML = html;
    placeSheet();
    dd.hidden = false; isOpen = true;
    input.setAttribute('aria-expanded', 'true');
  }
  function hide() { dd.hidden = true; isOpen = false; input.setAttribute('aria-expanded', 'false'); }

  function renderEmpty() {
    var h = history(), html = '';
    if (h.length) {
      html += '<div class="site-search__section site-search__section--history"><div class="site-search__section-head"><span class="site-search__section-title">Histórico</span><button type="button" class="site-search__clear" data-search-clear>Limpar</button></div><ul class="site-search__list">' +
        h.map(function (t) { return '<li><a class="site-search__link" href="' + termUrl(t) + '">' + ICON_HISTORY + '<span>' + esc(t) + '</span></a></li>'; }).join('') + '</ul></div>';
    }
    if (topTerms.length) {
      html += '<div class="site-search__section site-search__section--top"><div class="site-search__section-head"><span class="site-search__section-title">Mais buscados</span></div><ul class="site-search__list">' +
        topTerms.map(function (t, i) { return '<li><a class="site-search__link" href="' + termUrl(t) + '"><span class="site-search__badge">' + (i + 1) + '</span><span>' + esc(t) + '</span></a></li>'; }).join('') + '</ul></div>';
    }
    show(html);
  }
  function formatTerm(t, q) {
    var i = t.toLowerCase().indexOf(q.toLowerCase());
    if (i < 0) return '<strong>' + esc(t) + '</strong>';
    var end = i + q.length;
    return esc(t.slice(0, end)) + '<strong>' + esc(t.slice(end)) + '</strong>';
  }
  /* 60ml antes do 10ml (mesma regra da página de resultados): a Shopify manda até 10 produtos e aparecem os
     5 primeiros nesta ordem: disponíveis, 10ml disponíveis, esgotados, 10ml esgotados. */
  function sessentaPrimeiro(ps) {
    var grupos = [[], [], [], []];
    ps.forEach(function (p) { grupos[(p.available === false ? 2 : 0) + (/\b10ml\b/i.test(p.title || '') ? 1 : 0)].push(p); });
    return grupos[0].concat(grupos[1], grupos[2], grupos[3]).slice(0, LIMIT);
  }
  function renderResults(q, data) {
    var r = (data && data.resources && data.resources.results) || {};
    var qs = (r.queries || []).slice(0, LIMIT), ps = sessentaPrimeiro(r.products || []), html = '';
    if (qs.length) {
      html += '<div class="site-search__section site-search__section--terms"><ul class="site-search__list">' +
        qs.map(function (x) { return '<li><a class="site-search__link" href="' + termUrl(x.text) + '">' + ICON_SEARCH + '<p>' + formatTerm(String(x.text || ''), q) + '</p></a></li>'; }).join('') + '</ul></div>';
    }
    if (ps.length) {
      html += '<div class="site-search__section site-search__section--products"><div class="site-search__section-head"><span class="site-search__section-title">Produtos sugeridos</span></div><ul class="site-search__list">' +
        ps.map(function (p) {
          var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
          var old = (p.compare_at_price_min && parseFloat(p.compare_at_price_min) > parseFloat(p.price)) ? '<span class="site-search__price-old">' + money(p.compare_at_price_min) + '</span>' : '';
          return '<li class="site-search__product"><a class="site-search__product-link" href="' + esc(p.url || '#') + '">' +
            (img ? '<span class="site-search__product-img"><img src="' + esc(sized(img, 112)) + '" alt="" width="56" height="56" loading="lazy"></span>' : '') +
            '<span class="site-search__product-content"><span class="site-search__product-title">' + esc(p.title || '') + '</span><span class="site-search__product-prices">' + old + '<span class="site-search__price">' + money(p.price) + '</span></span></span></a></li>';
        }).join('') + '</ul></div>';
    }
    show(html);
  }
  function fetchSuggest(q) {
    var my = ++seq;
    if (ctrl) { try { ctrl.abort(); } catch (e) {} }
    ctrl = window.AbortController ? new AbortController() : null;
    /* Enquanto digita, número de 1 dígito fica como está (a busca por nome não acha "8"; a partir de "82" acha). */
    var url = suggestUrl + '?q=' + encodeURIComponent(porNome(q, true) || q) + '&resources[type]=product,query&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][prefix]=last';
    fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { if (my !== seq) return; if (!data) { hide(); return; } renderResults(q, data); })
      .catch(function () {});
  }
  function update() {
    var q = input.value.trim();
    if (!q) { seq++; renderEmpty(); return; }
    fetchSuggest(q);
  }

  /* Volta o foco ao campo sem reabrir nem recarregar o painel (o focus do campo chama update). */
  function focusInput() { if (document.activeElement !== input) { skipFocus = true; input.focus(); } }
  /* Teclado no painel (auditoria SEO V1, achado do popup da busca): o painel é um dialog (ver o comentário
     em sections/header.liquid), então a seta para baixo leva o foco do campo para os links e o botão
     "Limpar"; as setas andam entre eles; seta para cima no primeiro e Esc voltam ao campo. Com o painel
     fechado (depois do Esc), a seta para baixo abre de novo. */
  function itens() { return Array.prototype.slice.call(dd.querySelectorAll('a[href], button')); }
  input.addEventListener('focus', function () { if (skipFocus) { skipFocus = false; return; } clearTimeout(timer); update(); });
  input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(update, 250); });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { hide(); input.blur(); return; }
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (!isOpen) { clearTimeout(timer); update(); return; }
      var l = itens(); if (l.length) l[0].focus();
    }
  });
  input.addEventListener('blur', function () {
    setTimeout(function () { if (document.activeElement !== input && !dd.contains(document.activeElement)) hide(); }, 120);
  });
  dd.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.preventDefault(); hide(); focusInput(); return; }
    var l = itens(), i = l.indexOf(document.activeElement);
    if (i < 0) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); if (i < l.length - 1) l[i + 1].focus(); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); if (i > 0) l[i - 1].focus(); else focusInput(); }
  });
  /* Tab para fora do painel fecha (antes ele ficava aberto até um clique fora). */
  dd.addEventListener('focusout', function () {
    setTimeout(function () { if (isOpen && document.activeElement !== input && !dd.contains(document.activeElement)) hide(); }, 120);
  });
  form.addEventListener('submit', function (e) {
    saveHistory(input.value); hide();
    var n = porNome(input.value);
    if (!n) return;
    /* Vai direto para a busca por nome (sem passar pelo redirecionamento da página de resultados). */
    e.preventDefault();
    var p = new URLSearchParams(new FormData(form));
    p.set('q', n);
    window.location.assign(searchUrl + '?' + p.toString());
  });
  dd.addEventListener('mousedown', function (e) { e.preventDefault(); });   /* clicar no painel nao tira o foco do campo */
  dd.addEventListener('click', function (e) {
    var clear = e.target.closest ? e.target.closest('[data-search-clear]') : null;
    if (clear) { clearHistory(); renderEmpty(); focusInput(); return; }
    var a = e.target.closest ? e.target.closest('a.site-search__link') : null;
    if (a) { var m = /[?&]q=([^&]+)/.exec(a.getAttribute('href') || ''); if (m) saveHistory(legivel(decodeURIComponent(m[1].replace(/\+/g, ' ')))); hide(); }
  });
  document.addEventListener('click', function (e) { if (!isOpen) return; if (wrap.contains(e.target) || dd.contains(e.target)) return; hide(); });
  window.addEventListener('resize', function () { if (isOpen) placeSheet(); });
})();
